export default __webpack_public_path__ + "static/media/pitch-date.93b4cc80.png";